import type { Form } from 'payments-lib-types';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormGroup } from '@/components/form/groups/FormGroup';
import { Input } from '@/components/form/Input';
import { validatePhone } from '@/helpers/validators';
import type { OfUnion } from '@/types/common';
import type { MethodField } from '../helpers';

export const FieldPhoneNumber: FC<
  OfUnion<MethodField>[Form.MethodFieldType.Tel]
> = ({ fieldName, proposedValue, activeThemeMode }) => {
  const { t } = useTranslation('common');

  return (
    <FormGroup
      mode={activeThemeMode}
      title={t('auth.registration.form.phoneNumber')}
    >
      <Input
        initialValue={proposedValue}
        mode={activeThemeMode}
        name={fieldName}
        placeholder={t('auth.registration.form.phoneNumber')}
        type="tel"
        validate={validatePhone}
      />
    </FormGroup>
  );
};
